import { createClient } from '@supabase/supabase-js';

// Live Supabase configuration
const supabaseUrl = 'https://ocapzdudmzbmrwxmwmzj.supabase.co';
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im9jYXB6ZHVkbXpibXJ3eG13bXpqIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTg4MzEwMjksImV4cCI6MjA3NDQwNzAyOX0.VqPD9hM1DL7ujef6lFF4BKnwqU-R6bJxr7hekoC0HJk';

// Create Supabase client
export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true
  }
});

// This is now a live app - no more demo mode
export const isDemoMode = false;

// Demo credentials for testing (can be removed in production)
export const demoCredentials = {
  email: 'demo@medtracker.com',
  password: 'demo123456',
  name: 'Demo User',
  dateOfBirth: '1990-01-01'
};

// Database helper functions
export const createUserProfile = async (user, userData) => {
  const { data, error } = await supabase
    .from('users_mt2024')
    .insert([{
      id: user.id,
      email: user.email,
      name: userData.name,
      date_of_birth: userData.dateOfBirth,
    }])
    .select()
    .single();

  if (error) throw error;
  return data;
};

export const getUserProfile = async (userId) => {
  const { data, error } = await supabase
    .from('users_mt2024')
    .select('*')
    .eq('id', userId)
    .single();

  if (error) throw error;
  return data;
};

// Real-time subscription helper
export const subscribeToUserNotifications = (userId, callback) => {
  return supabase
    .channel('user-notifications')
    .on('postgres_changes', {
      event: 'INSERT',
      schema: 'public',
      table: 'notifications_mt2024',
      filter: `user_id=eq.${userId}`
    }, callback)
    .subscribe();
};

// Medicine reminder scheduler (would integrate with a background service)
export const scheduleMedicineReminders = async (medicine) => {
  // This would typically be handled by a background service/cron job
  // For now, we'll create immediate notifications for testing
  const notifications = medicine.timing.map(time => ({
    user_id: medicine.user_id,
    medicine_id: medicine.id,
    type: 'reminder',
    message: `Time to take your ${medicine.name} (${medicine.dosage})`,
    scheduled_time: new Date().toISOString(),
    is_read: false
  }));

  const { data, error } = await supabase
    .from('notifications_mt2024')
    .insert(notifications)
    .select();

  if (error) throw error;
  return data;
};

// Initialize database schema
export const initializeDatabase = async () => {
  try {
    // Create admin users table
    await supabase.rpc('create_admin_table_mt2024');
    
    // Create app settings table
    await supabase.rpc('create_app_settings_table_mt2024');
    
    // Create subscriptions table
    await supabase.rpc('create_subscriptions_table_mt2024');
    
    // Create payments table
    await supabase.rpc('create_payments_table_mt2024');
    
    console.log('Database schema initialized successfully');
  } catch (error) {
    console.error('Error initializing database:', error);
  }
};